import { InjectionToken } from '@angular/core';

import { AppEnvironment } from './app-environment';

export const APP_ENVIRONMENT: InjectionToken<AppEnvironment> = new InjectionToken('APP_ENVIRONMENT');
